import {ListConfigs} from '../../sharedComponent/SearchList/SearchList.types'

export const AGENT_LIST_CONFIGS: ListConfigs[] = [
  {
    headerName: 'Agent Name',
    apiFieldNameFirst: 'agentFirstName',
    apiFieldNameSecond: 'agentLastName',
    type: 'SPACE_SEPERATED',
    columnWidth: '150',
  },
  {
    headerName: 'Agent Email ID',
    apiFieldName: 'agentEmail',
    type: 'TEXT',
    columnWidth: '150',
  },
  {
    headerName: '# Product Assigned',
    apiFieldName: 'agentProductsCount',
    type: 'TEXT',
    columnWidth: '150',
  },
  {
    headerName: 'Created Date',
    apiFieldName: 'agentCreatedAt',
    type: 'LOCALTIME',
    columnWidth: '150',
  },
  {
    headerName: 'Agent Status',
    apiFieldName: 'agentStatus',
    type: 'STATUS_BADGE',
    columnWidth: '150',
  },
  {
    headerName: 'Active Status',
    apiFieldName: 'isDisabled',
    type: 'ACTIVE_BADGE',
    columnWidth: '150',
  },
]
